import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Report, type ResolveParams } from "../../../domain/entities/report";
import { type ReportsDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const resolveReport = createAsyncThunk<
  Report,
  ResolveParams,
  { dispatch: ReportsDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RESOLVE_REPORT, async (params, { extra }) => {
  return await extra.reportsRepo.resolve(params);
});
